"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _Client_auth, _Client_logLevel, _Client_logger, _Client_prefixUrl, _Client_timeoutMs, _Client_notionVersion, _Client_fetch, _Client_agent, _Client_userAgent;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var logging_1 = require("./logging");

var errors_1 = require("./errors");

var utils_1 = require("./utils");

var api_endpoints_1 = require("./api-endpoints");

var node_fetch_1 = require("node-fetch");

var package_json_1 = require("../package.json");

var Client = /*#__PURE__*/function () {
  function Client(options) {
    var _this = this;

    _classCallCheck(this, Client);

    var _a, _b, _c, _d, _e, _f;

    _Client_auth.set(this, void 0);

    _Client_logLevel.set(this, void 0);

    _Client_logger.set(this, void 0);

    _Client_prefixUrl.set(this, void 0);

    _Client_timeoutMs.set(this, void 0);

    _Client_notionVersion.set(this, void 0);

    _Client_fetch.set(this, void 0);

    _Client_agent.set(this, void 0);

    _Client_userAgent.set(this, void 0);
    /*
     * Notion API endpoints
     */


    this.blocks = {
      /**
       * Retrieve block
       */
      retrieve: function retrieve(args) {
        return _this.request({
          path: api_endpoints_1.getBlock.path(args),
          method: api_endpoints_1.getBlock.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.getBlock.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.getBlock.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      },

      /**
       * Update block
       */
      update: function update(args) {
        return _this.request({
          path: api_endpoints_1.updateBlock.path(args),
          method: api_endpoints_1.updateBlock.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.updateBlock.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.updateBlock.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      },

      /**
       * Delete block
       */
      delete: function _delete(args) {
        return _this.request({
          path: api_endpoints_1.deleteBlock.path(args),
          method: api_endpoints_1.deleteBlock.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.deleteBlock.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.deleteBlock.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      },
      children: {
        /**
         * Append block children
         */
        append: function append(args) {
          return _this.request({
            path: api_endpoints_1.appendBlockChildren.path(args),
            method: api_endpoints_1.appendBlockChildren.method,
            query: (0, utils_1.pick)(args, api_endpoints_1.appendBlockChildren.queryParams),
            body: (0, utils_1.pick)(args, api_endpoints_1.appendBlockChildren.bodyParams),
            auth: args === null || args === void 0 ? void 0 : args.auth
          });
        },

        /**
         * Retrieve block children
         */
        list: function list(args) {
          return _this.request({
            path: api_endpoints_1.listBlockChildren.path(args),
            method: api_endpoints_1.listBlockChildren.method,
            query: (0, utils_1.pick)(args, api_endpoints_1.listBlockChildren.queryParams),
            body: (0, utils_1.pick)(args, api_endpoints_1.listBlockChildren.bodyParams),
            auth: args === null || args === void 0 ? void 0 : args.auth
          });
        }
      }
    };
    this.databases = {
      /**
       * List databases
       *
       * @deprecated Please use `search`
       */
      list: function list(args) {
        return _this.request({
          path: api_endpoints_1.listDatabases.path(),
          method: api_endpoints_1.listDatabases.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.listDatabases.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.listDatabases.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      },

      /**
       * Retrieve a database
       */
      retrieve: function retrieve(args) {
        return _this.request({
          path: api_endpoints_1.getDatabase.path(args),
          method: api_endpoints_1.getDatabase.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.getDatabase.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.getDatabase.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      },

      /**
       * Query a database
       */
      query: function query(args) {
        return _this.request({
          path: api_endpoints_1.queryDatabase.path(args),
          method: api_endpoints_1.queryDatabase.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.queryDatabase.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.queryDatabase.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      },

      /**
       * Create a database
       */
      create: function create(args) {
        return _this.request({
          path: api_endpoints_1.createDatabase.path(),
          method: api_endpoints_1.createDatabase.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.createDatabase.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.createDatabase.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      },

      /**
       * Update a database
       */
      update: function update(args) {
        return _this.request({
          path: api_endpoints_1.updateDatabase.path(args),
          method: api_endpoints_1.updateDatabase.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.updateDatabase.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.updateDatabase.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      }
    };
    this.pages = {
      /**
       * Create a page
       */
      create: function create(args) {
        return _this.request({
          path: api_endpoints_1.createPage.path(),
          method: api_endpoints_1.createPage.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.createPage.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.createPage.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      },

      /**
       * Retrieve a page
       */
      retrieve: function retrieve(args) {
        return _this.request({
          path: api_endpoints_1.getPage.path(args),
          method: api_endpoints_1.getPage.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.getPage.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.getPage.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      },

      /**
       * Update page properties
       */
      update: function update(args) {
        return _this.request({
          path: api_endpoints_1.updatePage.path(args),
          method: api_endpoints_1.updatePage.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.updatePage.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.updatePage.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      },
      properties: {
        /**
         * Retrieve page property
         */
        retrieve: function retrieve(args) {
          return _this.request({
            path: api_endpoints_1.getPageProperty.path(args),
            method: api_endpoints_1.getPageProperty.method,
            query: (0, utils_1.pick)(args, api_endpoints_1.getPageProperty.queryParams),
            body: (0, utils_1.pick)(args, api_endpoints_1.getPageProperty.bodyParams),
            auth: args === null || args === void 0 ? void 0 : args.auth
          });
        }
      }
    };
    this.users = {
      /**
       * Retrieve a user
       */
      retrieve: function retrieve(args) {
        return _this.request({
          path: api_endpoints_1.getUser.path(args),
          method: api_endpoints_1.getUser.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.getUser.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.getUser.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      },

      /**
       * List all users
       */
      list: function list(args) {
        return _this.request({
          path: api_endpoints_1.listUsers.path(),
          method: api_endpoints_1.listUsers.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.listUsers.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.listUsers.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      },

      /**
       * Get details about bot
       */
      me: function me(args) {
        return _this.request({
          path: api_endpoints_1.getSelf.path(),
          method: api_endpoints_1.getSelf.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.getSelf.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.getSelf.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      }
    };
    this.comments = {
      /**
       * Create a comment
       */
      create: function create(args) {
        return _this.request({
          path: api_endpoints_1.createComment.path(),
          method: api_endpoints_1.createComment.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.createComment.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.createComment.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      },

      /**
       * List comments
       */
      list: function list(args) {
        return _this.request({
          path: api_endpoints_1.listComments.path(),
          method: api_endpoints_1.listComments.method,
          query: (0, utils_1.pick)(args, api_endpoints_1.listComments.queryParams),
          body: (0, utils_1.pick)(args, api_endpoints_1.listComments.bodyParams),
          auth: args === null || args === void 0 ? void 0 : args.auth
        });
      }
    };
    /**
     * Search
     */

    this.search = function (args) {
      return _this.request({
        path: api_endpoints_1.search.path(),
        method: api_endpoints_1.search.method,
        query: (0, utils_1.pick)(args, api_endpoints_1.search.queryParams),
        body: (0, utils_1.pick)(args, api_endpoints_1.search.bodyParams),
        auth: args === null || args === void 0 ? void 0 : args.auth
      });
    };

    __classPrivateFieldSet(this, _Client_auth, options === null || options === void 0 ? void 0 : options.auth, "f");

    __classPrivateFieldSet(this, _Client_logLevel, (_a = options === null || options === void 0 ? void 0 : options.logLevel) !== null && _a !== void 0 ? _a : logging_1.LogLevel.WARN, "f");

    __classPrivateFieldSet(this, _Client_logger, (_b = options === null || options === void 0 ? void 0 : options.logger) !== null && _b !== void 0 ? _b : (0, logging_1.makeConsoleLogger)(package_json_1.name), "f");

    __classPrivateFieldSet(this, _Client_prefixUrl, ((_c = options === null || options === void 0 ? void 0 : options.baseUrl) !== null && _c !== void 0 ? _c : "https://api.notion.com") + "/v1/", "f");

    __classPrivateFieldSet(this, _Client_timeoutMs, (_d = options === null || options === void 0 ? void 0 : options.timeoutMs) !== null && _d !== void 0 ? _d : 60000, "f");

    __classPrivateFieldSet(this, _Client_notionVersion, (_e = options === null || options === void 0 ? void 0 : options.notionVersion) !== null && _e !== void 0 ? _e : Client.defaultNotionVersion, "f");

    __classPrivateFieldSet(this, _Client_fetch, (_f = options === null || options === void 0 ? void 0 : options.fetch) !== null && _f !== void 0 ? _f : node_fetch_1.default, "f");

    __classPrivateFieldSet(this, _Client_agent, options === null || options === void 0 ? void 0 : options.agent, "f");

    __classPrivateFieldSet(this, _Client_userAgent, "notionhq-client/".concat(package_json_1.version), "f");
  }
  /**
   * Sends a request.
   *
   * @param path
   * @param method
   * @param query
   * @param body
   * @returns
   */


  _createClass(Client, [{
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var path, method, query, body, auth, bodyAsJsonString, url, _i, _Object$entries, _Object$entries$_i, key, value, headers, response, responseText, responseJson;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                path = _ref.path, method = _ref.method, query = _ref.query, body = _ref.body, auth = _ref.auth;
                this.log(logging_1.LogLevel.INFO, "request start", {
                  method: method,
                  path: path
                }); // If the body is empty, don't send the body in the HTTP request

                bodyAsJsonString = !body || Object.entries(body).length === 0 ? undefined : JSON.stringify(body);
                url = new URL("".concat(__classPrivateFieldGet(this, _Client_prefixUrl, "f")).concat(path));

                if (query) {
                  for (_i = 0, _Object$entries = Object.entries(query); _i < _Object$entries.length; _i++) {
                    _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];

                    if (value !== undefined) {
                      url.searchParams.append(key, String(value));
                    }
                  }
                }

                headers = _objectSpread(_objectSpread({}, this.authAsHeaders(auth)), {}, {
                  "Notion-Version": __classPrivateFieldGet(this, _Client_notionVersion, "f"),
                  "user-agent": __classPrivateFieldGet(this, _Client_userAgent, "f")
                });

                if (bodyAsJsonString !== undefined) {
                  headers["content-type"] = "application/json";
                }

                _context.prev = 7;
                _context.next = 10;
                return errors_1.RequestTimeoutError.rejectAfterTimeout(__classPrivateFieldGet(this, _Client_fetch, "f").call(this, url.toString(), {
                  method: method.toUpperCase(),
                  headers: headers,
                  body: bodyAsJsonString,
                  agent: __classPrivateFieldGet(this, _Client_agent, "f")
                }), __classPrivateFieldGet(this, _Client_timeoutMs, "f"));

              case 10:
                response = _context.sent;
                _context.next = 13;
                return response.text();

              case 13:
                responseText = _context.sent;

                if (response.ok) {
                  _context.next = 16;
                  break;
                }

                throw (0, errors_1.buildRequestError)(response, responseText);

              case 16:
                responseJson = JSON.parse(responseText);
                this.log(logging_1.LogLevel.INFO, "request success", {
                  method: method,
                  path: path
                });
                return _context.abrupt("return", responseJson);

              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](7);

                if ((0, errors_1.isNotionClientError)(_context.t0)) {
                  _context.next = 25;
                  break;
                }

                throw _context.t0;

              case 25:
                // Log the error if it's one of our known error types
                this.log(logging_1.LogLevel.WARN, "request fail", {
                  code: _context.t0.code,
                  message: _context.t0.message
                });

                if ((0, errors_1.isHTTPResponseError)(_context.t0)) {
                  // The response body may contain sensitive information so it is logged separately at the DEBUG level
                  this.log(logging_1.LogLevel.DEBUG, "failed response body", {
                    body: _context.t0.body
                  });
                }

                throw _context.t0;

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 21]]);
      }));

      function request(_x) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
    /**
     * Emits a log message to the console.
     *
     * @param level The level for this message
     * @param args Arguments to send to the console
     */

  }, {
    key: "log",
    value: function log(level, message, extraInfo) {
      if ((0, logging_1.logLevelSeverity)(level) >= (0, logging_1.logLevelSeverity)(__classPrivateFieldGet(this, _Client_logLevel, "f"))) {
        __classPrivateFieldGet(this, _Client_logger, "f").call(this, level, message, extraInfo);
      }
    }
    /**
     * Transforms an API key or access token into a headers object suitable for an HTTP request.
     *
     * This method uses the instance's value as the default when the input is undefined. If neither are defined, it returns
     * an empty object
     *
     * @param auth API key or access token
     * @returns headers key-value object
     */

  }, {
    key: "authAsHeaders",
    value: function authAsHeaders(auth) {
      var headers = {};
      var authHeaderValue = auth !== null && auth !== void 0 ? auth : __classPrivateFieldGet(this, _Client_auth, "f");

      if (authHeaderValue !== undefined) {
        headers["authorization"] = "Bearer ".concat(authHeaderValue);
      }

      return headers;
    }
  }]);

  return Client;
}();

exports.default = Client;
_Client_auth = new WeakMap(), _Client_logLevel = new WeakMap(), _Client_logger = new WeakMap(), _Client_prefixUrl = new WeakMap(), _Client_timeoutMs = new WeakMap(), _Client_notionVersion = new WeakMap(), _Client_fetch = new WeakMap(), _Client_agent = new WeakMap(), _Client_userAgent = new WeakMap();
Client.defaultNotionVersion = "2022-06-28";